import { IDeviceService } from '../domain/interfaces/IDeviceService';
import { IDevice } from '../interface/Device';

const GetCurrencyUseCase = async (
  deviceService: IDeviceService,
  device: IDevice
): Promise<{ code: string; symbol: string; }> => {
  const response = await deviceService.getCurrency(device.localId);
  return { ...response };
};

export default GetCurrencyUseCase;


